export const MEGABATTLE_TESTS_REQUEST = "MEGABATTLE_TESTS_REQUEST";
export const MEGABATTLE_TESTS_SUCCESS = "MEGABATTLE_TESTS_SUCCESS";
export const  MEGABATTLE_TESTS_FAILURE = "MEGABATTLE_TESTS_FAILURE";